import { Check } from '@/assets/icons'
import clsx from 'clsx'
import { CaseStatusEnum } from '@/citator/schema/case-status-schema'
import { kCaseStatusDefinitions } from '@/citator/utils/case-status-definitions'
import { kCaseTreatmentVisualsByStatus } from '@/citator/utils/case-treatment-visuals'

export type CaseStatusCheckedLabelSize = 'compact' | 'default'

type CaseStatusCheckedLabelProps = {
  label?: string
  size?: CaseStatusCheckedLabelSize
  className?: string
}

const sizeStyles: Record<CaseStatusCheckedLabelSize, { icon: string; text: string }> = {
  compact: {
    icon: 'size-3',
    text: 'text-2xs leading-[11.2px]',
  },
  default: {
    icon: 'size-4',
    text: 'text-xs leading-4',
  },
}

export function CaseStatusCheckedLabel({
  label = kCaseStatusDefinitions[CaseStatusEnum.likely_good].label,
  size = 'default',
  className,
}: CaseStatusCheckedLabelProps) {
  const styles = sizeStyles[size]

  return (
    <span
      className={clsx('inline-flex items-center gap-[2px] whitespace-nowrap', kCaseTreatmentVisualsByStatus[CaseStatusEnum.likely_good].colorClass, className)}
    >
      <Check className={clsx('shrink-0', styles.icon)} aria-hidden="true" />
      <span className={styles.text}>{label}</span>
    </span>
  )
}
